import React from "react";
import Modal from "./Modal";

type SolvingLockModalProps = {
    open: boolean;
    onClose: () => void;
};

const SolvingLockModal: React.FC<SolvingLockModalProps> = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Résolution en cours"
            size="md"
            footer={
                <button
                    onClick={onClose}
                    className="inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white cursor-pointer hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                    Compris
                </button>
            }
        >
            <p className="text-gray-700">
                Les assignations manuelles ne peuvent pas être effectuées lorsque la
                résolution de l'horaire est en cours.
            </p>
        </Modal>
    );
};

export default SolvingLockModal;
